import React from 'react';
import {Backdrop, Button, CircularProgress, Stack, Typography} from '@mui/material';

export const BOOTSTRAP_WATCHDOG_MS = 10000;

export default function BootstrapScreen({
    title,
    message,
    onRetry,
    retryLabel = 'Retry',
    onSecondary,
    secondaryLabel,
    secondaryDisabled = false,
    alert
}) {
    if (!title) {
        return (
            <Backdrop aria-hidden={false} invisible open>
                <CircularProgress color="primary" />
            </Backdrop>
        );
    }

    return (
        <Backdrop aria-hidden={false} invisible open>
            <Stack role="status" spacing={2} sx={{alignItems: 'center', p: 3, textAlign: 'center'}}>
                <Typography variant="h6">{title}</Typography>
                {message && <Typography variant="body2" sx={{color: 'text.secondary'}}>{message}</Typography>}
                <Stack direction="row" spacing={1}>
                    {onRetry && <Button variant="contained" onClick={onRetry}>{retryLabel}</Button>}
                    {onSecondary && (
                        <Button variant="outlined" disabled={secondaryDisabled} onClick={onSecondary}>
                            {secondaryLabel}
                        </Button>
                    )}
                </Stack>
                {alert && <Typography role="alert" variant="body2" color="error">{alert}</Typography>}
            </Stack>
        </Backdrop>
    );
}
